import type {ValueOf} from '~/types/value-of'

export const aiQuestionType = {
  SUMMARY: 'SUMMARY',
  ADDRESS_INVOLVED: 'ADDRESS_INVOLVED'
} as const
export type aiQuestionType = ValueOf<typeof aiQuestionType>

export const aiSummaryDataType = {
  USER_TRANSACTION: 'USER_TRANSACTION',
  STATE_CHECKPOINT_TRANSACTION: 'STATE_CHECKPOINT_TRANSACTION',
  BLOCK_METADATA_TRANSACTION: 'BLOCK_METADATA_TRANSACTION',
  BLOCK: 'BLOCK',
  TRANSACTION: 'TRANSACTION',
} as const
export type aiSummaryDataType = ValueOf<typeof aiSummaryDataType>

export interface IAiSummaryRequestParam {
  question?: aiQuestionType;
  dataType: aiSummaryDataType;
}